import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "ec-619af16e-5731-4b7b-9412-2422f8a59d76-__Layer_1",
  "enable-background": "new 0 0 72 72",
  height: "512",
  viewBox: "0 0 72 72",
  width: "512",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g id=\"ec-78312d1a-ced7-428e-9016-2614eafddb47-__Layer_2_1_\"><g id=\"ec-03ac1f11-74a5-4f1b-a823-0e9d6eec5d82-__Layer_1-2\"><g id=\"ec-d7630d91-9983-4a6d-a8d2-f1a0f5a0a859-__format_align_center\"><path d=\"m63 15h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m54 31h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m63 47h-54c-1.7 0-3-1.3-3-3s1.3-3 3-3h54c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path><path d=\"m54 63h-36c-1.7 0-3-1.3-3-3s1.3-3 3-3h36c1.7 0 3 1.3 3 3s-1.3 3-3 3z\"></path></g></g></g>", 1)
  ]))]))
}
export default { render: render }